(function () {
  function scrollTabIntoView(tab, tabsContainer, tabs) {
    if (!tab || !tabsContainer) return;

    var peek = 24;
    var index = Array.prototype.indexOf.call(tabs, tab);
    var maxScroll = tabsContainer.scrollWidth - tabsContainer.clientWidth;

    if (maxScroll <= 0) return;

    var target;

    if (index === 0) {
      target = 0;
    } else if (index === tabs.length - 1) {
      target = maxScroll;
    } else {
      target = tab.offsetLeft - peek;
    }

    tabsContainer.scrollTo({
      left: Math.max(0, Math.min(target, maxScroll)),
      behavior: 'smooth'
    });
  }

  function initPurecoreProof(root) {
    var tabsContainer = root.querySelector('[data-purecore-tabs]');
    var tabs = root.querySelectorAll('[data-purecore-tab]');
    var panels = root.querySelectorAll('[data-purecore-panel]');
    if (!tabs.length || !panels.length) return;

    var activateTab = function (tab) {
      var index = tab.getAttribute('data-tab-index');

      tabs.forEach(function (item) {
        var isActive = item.getAttribute('data-tab-index') === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-tab-index') === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      scrollTabIntoView(tab, tabsContainer, tabs);
    };

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
    });

    var activeTab = root.querySelector('[data-purecore-tab].is-active');
    if (activeTab && tabsContainer) {
      scrollTabIntoView(activeTab, tabsContainer, tabs);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-purecore-proof]').forEach(initPurecoreProof);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var proof = event.target.querySelector('[data-purecore-proof]');
    if (proof) initPurecoreProof(proof);
  });
})();
